import { render, staticRenderFns } from "./layoutHeader.vue?vue&type=template&id=b5b16fb0"
import script from "./layoutHeader.vue?vue&type=script&lang=js"
export * from "./layoutHeader.vue?vue&type=script&lang=js"
import style0 from "./layoutHeader.vue?vue&type=style&index=0&id=b5b16fb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports